import * as Sentry from '@sentry/react';
import { useDidMount } from 'rooks';
import { useSelf } from '@/data/user';
import { useCompany } from '@/data/company';

const SentryProvider = ({ children }) => {
  const self = useSelf();
  const company = useCompany();

  useDidMount(() => {
    Sentry.setUser({
      id: self.data.uid,
      email: self.data.email,
      company: company.data.company_name
    });
  });

  return children;
};

export default SentryProvider;
